import store from '@/store/index'

interface BaseModel {
  id: string
}

export default class ModelInterface<dataType> {

  public static load (objectId: string) {
    return store.dispatch(this.loadDispatchName, objectId)
  }

  protected static loadDispatchName: string = ''
  protected data!: dataType & BaseModel
  protected editedProps: any

  constructor (data: dataType) {
    this.setData(data as dataType & BaseModel)
    this.editedProps = {}
  }

  public setData (data: dataType) {
    this.data = data as dataType & BaseModel
  }

  public getData () {
    return this.data
  }

  public getId () {
    return this.data.id
  }

  get id () {
    return this.getId()
  }
}
